@for (mediaElement of mediaType.mediaElements; track mediaElement; let i = $index) {
  @if (mediaElement.$$segmentOnly) {
    <ng-container *ngTemplateOutlet="stackTile;
      context: {mediaElement: mediaElement, index: i, segment: mediaElement.mediaObject.$$mediaSegments[0]}"></ng-container>
  } @else if (mediaElement.mediaObject.$$mediaSegments?.length) {
    <ng-container *ngTemplateOutlet="stackTile;
      context: {mediaElement: mediaElement, index: i, segment: null}"></ng-container>

    @for (segment of mediaElement.mediaObject.$$mediaSegments; track segment.segmentId) {
      <ng-container *ngTemplateOutlet="stackTile;
        context: {mediaElement: mediaElement, index: i, segment: segment}"></ng-container>
    }
  } @else {
    <button
      type="button"
      class="thumbnail-stack"
      [ngClass]="`thumbnail-stack--${mediaElement.mediaObject.object_type.toLowerCase()}`"
      matTooltipPosition="above"
      [matTooltip]="mediaElement.mediaObject.artifact_name"
      (click)="setMedia(i)"
      [attr.data-index]="i"
    >
      <div class="thumbnail-stack__inner" [ngClass]="tileClasses(i)">
        @if (mediaElement.mediaObject.object_type.toLowerCase() === 'model3d') {
          <i class="icon-object placeholder-icon"></i>
        } @else {
          @if (!invalidSrc[i]) {
            <img
              id='thumb-{{i}}'
              [alt]="mediaElement.mediaObject.artifact_name"
              [src]="mediaElement.mediaObject.$$thumbUrl"
              (error)="setInvalidSrc(i)"
            >
          } @else {
            <i class="icon-image-attention"></i>
          }
        }

        <div class="thumbnail-stack__media-type">
          <mat-icon>
            {{ getMaterialSymbol(mediaElement.mediaObject.object_type) }}
          </mat-icon>
        </div>
      </div>
    </button>
  }
}

<ng-template #stackTile let-mediaElement="mediaElement" let-i="index" let-segment="segment">
  <button
    type="button"
    class="thumbnail-stack thumbnail-stack--tile"
    [ngClass]="{'thumbnail-stack--segment': !!segment}"
    matTooltipPosition="above"
    [matTooltip]="segment ? segment.identifier : (rootObject?.identifier || mediaElement.mediaObject.artifact_name)"
    (click)="segment ? setSegment(i, segment) : setMedia(i)"
    [attr.data-index]="i"
  >
    <div class="thumbnail-stack__inner" [ngClass]="tileClasses(i, segment)">
      <span class="thumbnail-stack__name">
        {{ segment ? segment.identifier : (rootObject?.identifier || mediaElement.mediaObject.artifact_name) }}
      </span>

      <span class="thumbnail-stack__chip">
        @if (segment) {
          {{ 'TRANS__MEDIA_CAROUSEL__SEGMENT_OF' | translate }} {{ mediaElement.mediaObject.artifact_name }}
        } @else {
          {{ mediaElement.mediaObject.artifact_name }}
        }
      </span>

      @if (segment) {
        @if (segment.remarks) {
          <span class="thumbnail-stack__remarks">{{ segment.remarks }}</span>
        }
        <span class="thumbnail-stack__time">
          {{ msToTimecode(segment.start) }} – {{ msToTimecode(segment.end) }}
        </span>
      } @else {
        <span class="thumbnail-stack__remarks">
          {{ 'TRANS__MEDIA_CAROUSEL__WHOLE_RECORDING' | translate }}
        </span>
      }

      <div class="thumbnail-stack__media-type">
        <mat-icon>
          {{ segment ? 'graphic_eq' : getMaterialSymbol(mediaElement.mediaObject.object_type) }}
        </mat-icon>
      </div>
    </div>
  </button>
</ng-template>
